import { IntlShape } from 'react-intl';

type TranslationFunction = (intl: IntlShape) => string;

const userRoles: Record<string, TranslationFunction> = {
  'Administrator': intl => intl.formatMessage({ id: 'user_role.administrator', defaultMessage: 'Administrator' }),
  'Guest': intl => intl.formatMessage({ id: 'user_role.guest', defaultMessage: 'Guest' }),
  'Data manager': intl => intl.formatMessage({ id: 'user_role.data_manager', defaultMessage: 'Data manager' }),
  'People manager': intl => intl.formatMessage({ id: 'user_role.people_manager', defaultMessage: 'People manager' }),
  'Super administrator': intl =>
    intl.formatMessage({ id: 'user_role.super_administrator', defaultMessage: 'Super administrator' })
};

export const translateUserRole = (role: string, intl: IntlShape) => {
  return userRoles[role] ? userRoles[role](intl) : role;
};
